import { AttachFile, Edit } from "@mui/icons-material";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import HistoryFileUploadDialog from "./HistoryFileUploadDialog";

const History = ({
  history,
  handlePreviewFile,
  applicationId,
  onHistoryRevised,
}) => {
  const [data, setData] = useState(history ?? []);
  const [fileUploadRow, setFileUploadRow] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setData(history ?? []);
  }, [history]);
  const sortTable = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
    let sortedData;
    if (["ageRange", "gender"].includes(key)) {
      sortedData = [...data].sort((a, b) => {
        const aValue = a[key]?.name || "";
        const bValue = b[key]?.name || "";
        if (aValue < bValue) {
          return direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    } else {
      sortedData = [...data].sort((a, b) => {
        if (a[key] < b[key]) {
          return direction === "ascending" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    setData(sortedData);
  };

  const getIcon = (key) => {
    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        return <i className="fas fa-sort-up"></i>;
      } else {
        return <i className="fas fa-sort-down"></i>;
      }
    } else {
      return <i className="fas fa-sort"></i>;
    }
  };

  return (
    <>
      <div className="history-container">
        <div className="history-header">Ιστορικό</div>
        <div className="history-table-container">
          <table className="application-input-table">
            <thead>
              <tr>
                <th onClick={() => sortTable("logShortFormatted")}>
                  Ημερομηνία {getIcon("logShortFormatted")}
                </th>
                <th onClick={() => sortTable("action")}>
                  Ενέργεια {getIcon("action")}
                </th>
                <th onClick={() => sortTable("fullname")}>
                  Χρήστης {getIcon("fullname")}
                </th>
                <th>Αρχεία</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((row, index) => (
                <tr key={index}>
                  <td>{row?.logFormatted}</td>
                  <td>{row?.action}</td>
                  <td>{row?.fullName}</td>
                  <td align="center">
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                      flexWrap="wrap"
                    >
                      {row?.files?.map((file, index) => (
                        <span
                          key={index}
                          onClick={() => {
                            handlePreviewFile(file);
                          }}
                          style={{
                            color: "#387de7",
                            textDecoration: "underline",
                            cursor: "pointer",
                            marginTop: 3,
                          }}
                        >
                          {index + 1}
                          <AttachFile sx={{ fontSize: 20 }} />
                        </span>
                      ))}
                      {row?.canRevise && (
                        <Tooltip title="Upload file">
                          <IconButton
                            aria-label="Upload file"
                            color="primary"
                            size="small"
                            onClick={() => setFileUploadRow(row)}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Stack>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <HistoryFileUploadDialog
        open={!!fileUploadRow}
        row={fileUploadRow}
        applicationId={applicationId}
        onClose={() => setFileUploadRow(null)}
        onSuccess={onHistoryRevised}
      />
    </>
  );
};
export default History;
